import { render, staticRenderFns } from "./DeliveryKind.vue?vue&type=template&id=188fbc56"
import script from "./DeliveryKind.vue?vue&type=script&lang=js"
export * from "./DeliveryKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports